import type { PrintTaskThunk } from '../types/PrintTask';

/*
 * action types
 */

const types = {
  PROCESS_TASKS_BEFORE_TINT: 'PRINT_TASK/PROCESS_TASKS_BEFORE_TINT',
  PROCESS_TASKS_AFTER_CAN: 'PRINT_TASK/PROCESS_TASKS_AFTER_CAN',
  PROCESS_TASKS_AFTER_ERROR: 'PRINT_TASK/PROCESS_TASKS_AFTER_ERROR',
} as const;

/*
 * action creators - thunks
 */

const actions = {
  processTasksBeforeTint: (): PrintTaskThunk => (dispatch, getState) =>
    dispatch({
      type: types.PROCESS_TASKS_BEFORE_TINT,
      payload: getState(),
    }),
  processTasksAfterCan: (): PrintTaskThunk => (dispatch, getState) =>
    dispatch({
      type: types.PROCESS_TASKS_AFTER_CAN,
      payload: getState(),
    }),
  processTasksAfterError: (): PrintTaskThunk => (dispatch, getState) =>
    dispatch({
      type: types.PROCESS_TASKS_AFTER_ERROR,
      payload: getState(),
    }),
};

export { types as actionTypes, actions as default };
